import React from 'react'

const SelectorAccordionGroupContainer = (props) => {
  const { children, name, showName, open, handleOnClick, height} = props;
  let contentClasses = "selector-accordion-items-container-content"
  if (open) contentClasses += " open";
  return (
    <div className="selector-accordion-items-container">
      {
        showName &&  
          <div className="selector-accordion-items-container-title" onClick={() => handleOnClick()}>
            <div className="selector-accordion-items-container-title-text">{name}</div>
            <div className="selector-accordion-items-container-title-icon">{open ? "▼" : "◀"}</div>
          </div>
      } 
      <div className={contentClasses}>
        {children}
      </div>
    </div>
  )
}

export default SelectorAccordionGroupContainer